import { useContext, useState } from "react"
import { motion } from "framer-motion"
import TopoMenu from "../../../componentes/gerais/TopoMenu"
import MenuLateral from "../../../componentes/gerais/Menu"
import { Campo } from "../../../componentes/form/campo"
import { Spinner } from "../../../componentes/Spinner"
import { configAnim } from "../../../servicos/config/configAnim"
import IndicacoesAPI from "../../../servicos/IndicacoesAPI"
import { ContextoGeral } from "../../../contextos/ContextoGeral"
import { isIOS } from "../../../servicos/config/nativeBridge.js"
import { Alert, Card, Divider } from "@mui/material"
import { format, parse } from 'date-fns'

export default function RelatoriosIndicacoes() {
    const [menu, setMenu] = useState(false)
    const [resposta, setResposta] = useState('')
    const [data, setData] = useState({})
    const [lista, setLista] = useState('')
    const [buscando, setBuscando] = useState(false)
    const { dados } = useContext(ContextoGeral)

    const handleData = (ev) => {
        setData({ ...data, [ev.target.id === 'dataInicial' ? 'inicio' : 'fim']: ev.target.value })
    }

    async function todosIndicados() {
        setBuscando(true)
        setLista('')
        setResposta(<div className="mt-4"><Spinner /></div>)

        const resposta = await IndicacoesAPI.relatorioIndicados(dados, data)

        if (resposta.resultado) {
            setResposta(
                <Alert severity="success" className="text-center">
                    <div>{resposta.mensagem}</div>
                    {resposta.dados.length > 0 && (
                        <div>Quantidade de indicados: {resposta.dados.length}</div>
                    )}
                </Alert>
            )

            if (resposta.dados !== '') {
                setLista(
                    <div className="pb-4">
                        {resposta.dados.map(indicacao => (
                            <Card key={indicacao.id} className="p-4 mt-4">
                                <h4>{`#${indicacao.id}`}</h4>
                                <div className="opacity-80">
                                    <p className="text-lg">{indicacao.nome}</p>
                                    {indicacao.empresa && (
                                        <>
                                            <Divider />
                                            <small>{indicacao.empresa}</small>
                                        </>
                                    )}
                                    <Divider />
                                    <small>{indicacao.email}</small>
                                    <Divider />
                                    <small>{indicacao.celular}</small>
                                    <Divider />
                                    <small>{indicacao.telFixo}</small>
                                    <Divider />
                                    <small>{format(parse(indicacao.dataCadastro, 'yyyy-MM-dd HH:mm:ss', new Date()), "HH:mm dd/MM")}</small>
                                </div>
                            </Card>
                        ))}
                    </div>
                )
            }
        } else {
            setResposta(
                <Alert severity="warning" className="text-center">
                    {resposta.mensagem}
                </Alert>
            )
        }

        setBuscando(false)
    }

    async function servicosIndicados() {
        setBuscando(true)
        setLista('')
        setResposta(<div className="mt-4"><Spinner /></div>)

        const resposta = await IndicacoesAPI.relatorioIndicadosServicos(dados, data)

        if (resposta?.resultado) {
            setResposta(
                <Alert severity="success" className="text-center">
                    <div>{resposta.mensagem}</div>
                    <div>Quantidade de indicados: {resposta.dados.length}</div>
                </Alert>
            )

            if (resposta.dados && resposta.dados.length > 0) {
                setLista(
                    <div className="pb-4">
                        {resposta.dados.map(indicacao => (
                            <Card key={indicacao['s.id']} className="p-4 mt-4">
                                <h4>{`#${indicacao['s.id']}`}</h4>
                                <div className="opacity-80">
                                    <p className="text-lg">{indicacao['t.nome']}</p>
                                    <Divider />
                                    <small>
                                        {new Intl.NumberFormat('pt-BR', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        }).format(indicacao['s.valor'])}
                                    </small>
                                    <Divider />
                                    <small>
                                        {format(parse(indicacao['s.dataHora'], 'yyyy-MM-dd HH:mm:ss', new Date()), "HH:mm dd/MM")}
                                    </small>
                                    <Divider />
                                </div>
                            </Card>
                        ))}
                    </div>
                )
            }
        } else {
            setResposta(
                <Alert severity="warning" className="text-center">
                    {resposta.mensagem}
                </Alert>
            )
        }

        setBuscando(false)
    }

    return (
        <motion.div
            style={{ height: '100%' }}
            initial={configAnim.initial}
            animate={configAnim.animate}
            exit={configAnim.exit}
            transition={configAnim.transition}
        >
            <TopoMenu voltar="/app/indicarCliente" titulo="RELATÓRIO DE INDICAÇÕES" setShow={setMenu} />
            <div className="mx-4">
                <div>
                    <div className="text-center my-4">
                        Selecione um intervalo de datas:
                    </div>
                    {isIOS() ? (
                        <div className="flex w-full flex-row items-start gap-3">
                            <div className="min-w-0 flex-1">
                                <Campo
                                    id="dataInicial"
                                    tipo="date"
                                    label="Data Inicial"
                                    value={data.inicio}
                                    onChange={handleData}
                                />
                            </div>
                            <div className="min-w-0 flex-1">
                                <Campo
                                    id="dataFinal"
                                    tipo="date"
                                    label="Data Final"
                                    value={data.fim}
                                    onChange={handleData}
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="block">
                            <div className="inline-block align-top" style={{ width: "49%" }}>
                                <Campo
                                    id="dataInicial"
                                    tipo="date"
                                    label="Data Inicial"
                                    value={data.inicio}
                                    onChange={handleData}
                                />
                            </div>
                            <div className="inline-block align-top ml-[2%]" style={{ width: "49%" }}>
                                <Campo
                                    id="dataFinal"
                                    tipo="date"
                                    label="Data Final"
                                    value={data.fim}
                                    onChange={handleData}
                                />
                            </div>
                        </div>
                    )}

                    <div className="mt-4">
                        <button
                            className="w-full bg-blue-600 text-white font-semibold py-2 rounded hover:bg-blue-700 transition"
                            onClick={todosIndicados}
                            disabled={buscando}
                        >
                            Todos os Indicados
                        </button>
                    </div>
                    <div className="mt-4">
                        <button
                            className="w-full bg-blue-600 text-white font-semibold py-2 rounded hover:bg-blue-700 transition"
                            onClick={servicosIndicados}
                            disabled={buscando}
                        >
                            Serviços dos Indicados
                        </button>
                    </div>
                    <div className="mt-4">
                        {resposta}
                        {lista}
                    </div>
                </div>
            </div>
            <MenuLateral show={menu} setShow={setMenu} ativo="3" />
        </motion.div>
    )
}